import { Injectable } from '@angular/core';
import { MembersService, PushService } from '@careapp-group/ng-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  FrontendApi,
  RecoveryFlow,
  RecoveryFlowState,
  RegistrationFlow,
  VerificationFlow,
} from '@ory/client';
import { from, of as observableOf } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { State } from '../../reducers';

import * as actions from './logout.actions';

@Injectable()
export class AuthLogoutEffects {
  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RequestAuthLogoutAction),
      switchMap((action) => this.pushService.deleteDevices().pipe(map((response) => action))),
      switchMap((action) =>
        from(
          this.kratos.createBrowserLogoutFlow().then((flow) =>
            this.kratos.updateLogoutFlow({
              token: flow.data.logout_token,
            })
          )
        ).pipe(
          map((res) =>
            actions.ResponseSuccessAuthLogoutAction({
              stayOnCurrentRoute: action.stayOnCurrentRoute,
            })
          ),
          catchError((err) =>
            observableOf(
              actions.ResponseSuccessAuthLogoutAction({
                stayOnCurrentRoute: action.stayOnCurrentRoute,
              })
            )
          )
        )
      )
    )
  );

  forceLogout = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.ForceLogout401),
      map((action) => actions.RequestAuthLogoutAction({}))
    )
  );

  constructor(
    private actions$: Actions,
    private pushService: PushService,
    private kratos: FrontendApi
  ) {}
}
